var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIonManOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13V29.5C12.9978 29.6976 13.035 29.8937 13.1096 30.0767C13.1842 30.2597 13.2946 30.426 13.4343 30.5657C13.5741 30.7054 13.7403 30.8158 13.9233 30.8904C14.1064 30.965 14.3024 31.0023 14.5 31V31C14.6976 31.0023 14.8937 30.965 15.0767 30.8904C15.2597 30.8158 15.426 30.7054 15.5657 30.5657C15.7055 30.426 15.8159 30.2597 15.8905 30.0767C15.965 29.8937 16.0023 29.6976 16 29.5",
    stroke: "#5D5D5D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21V29.5C15.9978 29.6976 16.035 29.8937 16.1096 30.0767C16.1842 30.2597 16.2946 30.426 16.4343 30.5657C16.5741 30.7054 16.7403 30.8158 16.9233 30.8904C17.1064 30.965 17.3024 31.0023 17.5 31C17.6976 31.0023 17.8937 30.965 18.0767 30.8904C18.2597 30.8158 18.426 30.7054 18.5657 30.5657C18.7055 30.426 18.8159 30.2597 18.8905 30.0767C18.965 29.8937 19.0023 29.6976 19 29.5V13",
    stroke: "#5D5D5D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12V17.5C13.0024 17.6976 12.9652 17.8937 12.8906 18.0768C12.8161 18.2598 12.7057 18.4261 12.5659 18.5659C12.4262 18.7056 12.2599 18.816 12.0768 18.8906C11.8938 18.9652 11.6977 19.0023 11.5 19V19C11.3024 19.0023 11.1063 18.9652 10.9233 18.8906C10.7402 18.816 10.5739 18.7056 10.4342 18.5659C10.2944 18.4261 10.184 18.2598 10.1094 18.0768C10.0349 17.8937 9.9977 17.6976 10 17.5V12C10 11.2044 10.3161 10.4413 10.8787 9.87868C11.4413 9.31607 12.2044 9 13 9H19C19.7957 9 20.5588 9.31607 21.1214 9.87868C21.684 10.4413 22 11.2044 22 12V17.5C22.0024 17.6976 21.9652 17.8937 21.8906 18.0768C21.8161 18.2598 21.7057 18.4261 21.5659 18.5659C21.4262 18.7056 21.2599 18.816 21.0768 18.8906C20.8938 18.9652 20.6977 19.0023 20.5 19V19C20.3024 19.0023 20.1063 18.9652 19.9233 18.8906C19.7402 18.816 19.5739 18.7056 19.4342 18.5659C19.2944 18.4261 19.184 18.2598 19.1094 18.0768C19.0349 17.8937 18.9977 17.6976 19 17.5V12",
    stroke: "#5D5D5D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C17.3807 6 18.5 4.88071 18.5 3.5C18.5 2.11929 17.3807 1 16 1C14.6193 1 13.5 2.11929 13.5 3.5C13.5 4.88071 14.6193 6 16 6Z",
    stroke: "#5D5D5D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonManOutline);
export default __webpack_public_path__ + "static/media/ion_man-outline.51a272a45aa17045cb1badb8e0640f8d.svg";
export { ForwardRef as ReactComponent };